import React from 'react';
import { useSelector } from "react-redux";
import { useWizard } from 'react-use-wizard';
import { formatAmount2, ocutarNroCuenta } from '../../../../lib/utils/utilitarios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faInfo } from '@fortawesome/free-solid-svg-icons';
import ButtonComponent from '../../../../components/button/button_component';
import NotificationComponent from '../../../../components/notification/notification_component';
import HeaderWizardComponent from '../../../../components/headerWizard/headerWizard_component';
import cn from '../../../../lib/bem';
import { CONTENT_PAG } from '../../constants/content_pag';

import './confirmacionForm.scss';

const ConfirmacionForm = ({ descripcion1, descripcion2, nombreMonto, descInfo, mostrarFormularioEdicion }) => {
    
    const classes  = cn("confirmacionForm");

    const { activeStep, stepCount } = useWizard();

    const datosCuentaAsegurado   = useSelector((state) => state.rootReducers.refundInformation);
    const endosoPoliza           = useSelector((state) => state.rootReducers.endosoPoliza);
    const banco = useSelector((state) => state.rootReducers.productCatalog);

    return (
        <div>
            <HeaderWizardComponent stepNro={activeStep} stepMax={stepCount} title={"Cuenta bancaria"}/>

            <div className={classes()}>
                <p className={classes('titleConfDev')}><b>Confirmaci&oacute;n de datos</b></p>
                <p className={classes('descrConfDev')}>{descripcion1}</p>
                <p className={classes('descrConfDev')}>{descripcion2}</p>

                <div className={classes('divMonto')}>
                    <p className={classes('descrConfDev')}>{nombreMonto}</p>
                    <p className={classes('descrMontDev')}>{endosoPoliza.datosPoliza.simboloMoneda} <span>{ formatAmount2(endosoPoliza.datosPoliza.montoEndoso+'')}</span></p>
                </div>

                <div className={classes('divBanco')}>
                    <div className={classes('divBancoCheck')}>
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                    <div className={classes('divBancoInfo')}>
                        <p>{banco.getBank.descripcion}</p>
                        <p>{ocutarNroCuenta(datosCuentaAsegurado.numeroCuenta)}</p>
                    </div>
                    <div className={classes('divBancoBtn')}>
                        <ButtonComponent label={'btnEditarCuenta'} nombre={'Editar cuenta'} tipo={'button-white'} action={() => mostrarFormularioEdicion(CONTENT_PAG.PAG_EDIT)} disabled={false}/>
                    </div>
                </div>
                <div className={classes('divBancoBtn2')}>
                    <ButtonComponent label={'btnEditarCuenta2'} nombre={'Editar cuenta'} tipo={'button-white'} action={() => mostrarFormularioEdicion(CONTENT_PAG.PAG_EDIT)} disabled={false}/>
                </div>

                <div className={classes('divInformation')}>
                    <NotificationComponent faIcon={faInfo} textNotification={descInfo} tipo="information"/>
                </div>

                {/* <div className={classes('divTerminos')}>
                    <InputRadioTextComponent value={datosCuentaAsegurado.aceptoTerminos} accion={(e) => dispatch(aceptTerms(e))}/>
                </div> */}
                <div className={classes('btnContinuar')}>
                    <ButtonComponent label={'btnContinuar'} nombre={'Continuar'} tipo={'button-red'} action={() => mostrarFormularioEdicion(CONTENT_PAG.PAG_VERI)} disabled={false}/>
                </div>
            </div>
        </div>
    );
};

export default ConfirmacionForm;
